export default __webpack_public_path__ + "static/Quickinstallation_Tile_8815_Step_11-c6449ca5c300f593b1e2cecf30ea69dc.webp";